<template>
  <colored-icon
    :color="getColor()"
    :icon-class="getClass() + ' ' + getColorClass()"
    :shadow="false"
    style="cursor: pointer"
    @click="toggle()"
  ></colored-icon>
</template>

<script>
import ColoredIcon from '@kanrisha/components/Icons/ColoredIcon';

export default {
  components: {
    ColoredIcon,
  },
  props: {
    value: { type: [String, Array], default: '' },
    column: { type: String, default: '' },
    iconClass: { type: String, default: '' },
    id: { type: Number, default: null },
    color: { type: String, default: () => '' },
    resourceType: { type: String, default: '' },
    mutation: { type: String, default: 'toggle.icon(ACTIVE, INACTIVE)' },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const toggle = () => {
      let params = { id: props.id };
      let options = getOptions();
      params[props.column] = options[!isChecked() ? 1 : 0];
      emit('update:data', params);
    };

    const getOptions = () => {
      return String(props.mutation.match(/[A-Z0-9_-]*, [A-Z0-9_-]*/g)).split(', ');
    };

    const getStatus = () => {
      let status;
      let options = getOptions();
      if (props.value !== options[1] && !(options[1] === 'NULL' && props.value === null)) {
        status = options[1];
      } else {
        status = options[0];
      }

      return status;
    };

    const isChecked = () => {
      let options = getOptions();

      return !(props.value !== options[1] && !(options[1] === 'NULL' && props.value === null));
    };

    const getClass = () => {
      let defaultClass = 'bi bi-circle-fill';

      return props.iconClass ? props.iconClass : defaultClass;
    };

    const getColorClass = () => {
      if (!props.color || props.color[0] === '#') {
        return '';
      }

      return 'text-' + props.color;
    };

    const getColor = () => {
      if (!props.color || props.color[0] !== '#') {
        return '#FFFFFF';
      }

      return props.color;
    };

    const valueIsSet = (value) => {
      if (value.length) {
        return value[0];
      }

      return value;
    };

    return {
      getClass,
      getColorClass,
      getColor,
      getStatus,
      isChecked,
      toggle,
      valueIsSet,
    };
  },
};
</script>
